import Phaser from "phaser";
import { EnemySentence } from "../entities/EnemySentence";

/** 入力結果 */
export interface InputResult {
  pickedIndex: number | null;
}

/** 入力システム（pointerdownのみ） */
export class InputSystem {
  private scene: Phaser.Scene;
  private onInput: ((result: InputResult) => void) | null = null;
  private enemy: EnemySentence | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /** 入力バインド */
  bind(enemy: EnemySentence, callback: (result: InputResult) => void): void {
    this.enemy = enemy;
    this.onInput = callback;
  }

  /** 敵を更新（文完走後の差し替え時に呼ぶ） */
  setEnemy(enemy: EnemySentence): void {
    this.enemy = enemy;
  }

  /** pointerdownイベントの処理（Sceneから呼ばれる） */
  handlePointerDown(pointer: Phaser.Input.Pointer): void {
    if (!this.enemy || !this.onInput) return;

    const worldX = pointer.worldX;
    const worldY = pointer.worldY;
    const index = this.enemy.pickCharAt(worldX, worldY);

    if (index !== null) {
      this.onInput({ pickedIndex: index });
    }
    // 背景タップは無視（missにしない）
  }
}
